import { SideBarButton } from '../../../settings/nav-list/recursive-sidebar/class/sidebar';
import { LIDS_ROLES_VIEWS_PERMISSIONS } from '@dep-lids/utils/roles-actions';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../../settings/nav-list/recursive-sidebar/configuration/preconfig';

export const LIDS_SIDENAV_OPTIONS: SideBarButton = {
  data: {
    name: 'Lids',
    appendUrl: './lids',
    roles: [...LIDS_ROLES_VIEWS_PERMISSIONS.sideNavActions.root],
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Agregar WO',
        url: '/add-work-order',
        roles: [...LIDS_ROLES_VIEWS_PERMISSIONS.sharedActions.addWorkOrder],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Planeacion',
        url: '/scheduler',
        roles: [...LIDS_ROLES_VIEWS_PERMISSIONS.sharedActions.scheduler],
        otherUniqueUrls: [
          '/scheduler',
          '/scheduler/sandblaster',
          '/scheduler/molded',
        ],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: [...LIDS_ROLES_VIEWS_PERMISSIONS.sharedActions.validation],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: [...LIDS_ROLES_VIEWS_PERMISSIONS.sharedActions.packingBox],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/lids',
      },
      options: PreConfigButton3,
    },
  ],
};
